import { render, staticRenderFns } from "./RelationImportOptions.vue?vue&type=template&id=75498f74"
import script from "./RelationImportOptions.vue?vue&type=script&lang=js"
export * from "./RelationImportOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports